import "primeicons/primeicons.css"; //icons
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';
import "primereact/resources/primereact.min.css"; //core css
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import { TabMenu } from 'primereact/tabmenu';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';
import logo from '../../assets/logoNavbar.png'; //
import authenticationService from '../../services/authentication.service';
import Burger from '../Burger/Burger';
import Menu from '../Menu/Menu';
import "./Navbar.css";
import { Image } from './Navbar.styles';
import { Avatar } from 'primereact/avatar';
import { Link, useHistory } from "react-router-dom";
import apis from "../../api";
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { Badge } from 'primereact/badge';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import useWindowDimensions from "../hooks/useDimensions";
import { ScrollPanel } from "primereact/scrollpanel";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Navbar
Description : Barra de navegación de la aplicación
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se implementa la barra de navegación desde cero.
2/11/2021 Cristian Andres Pizo Mina – Se agregaron Elementos de nombre de cuenta y salir.
02/03/2022 Santiago Coca Rojas Documentación - Se documenta el componente teniendo los cambios realizados con PrimeReact
================================================================================ */
function Navbar({ open, setOpen }) {

    const location = useLocation();
    const [username, setUsername] = useState(false)
    const [activeIndex, setActiveIndex] = useState(0)
    const node = useRef();
    let history = useHistory();
    const [notifications, setNotifications] = useState([])
    const { width, height } = useWindowDimensions()

    const op = useRef(null);
    const toast = useRef(null);

    const headers = {
        authorization: localStorage.getItem('token')
    }

    // set initial state
    const [user, showText] = useState(false);
    const [companyLogo, setCompanyLogo] = useState(localStorage.getItem("logo"))

    useEffect(() => {
        getNotifications()
    }, [])

    useEffect(() => {
        if (localStorage.getItem("logo")) {
            setCompanyLogo(localStorage.getItem("logo"))
        }
    }, [localStorage.getItem("logo")])

    let intervalId

    const interval = () => {
        intervalId = !intervalId && setInterval(() => {
            getNotifications()
        }, 300000)

        if (!localStorage.getItem('client')) {
            console.log("Se cierra")
            clearInterval(intervalId);
        }
    }

    useEffect(() => {
        interval()
        return () => clearInterval(intervalId)
    }, [localStorage.getItem('client')])

    // update state on button click
    const setText = (user) => {
        return showText(!user)
    }

    // Track events outside scope
    const clickOutside = (e) => {
        if (node.current.contains(e.target)) {
            // inside click
            return;
        }
        // outside click
        showText(false)
        setOpen(false)
    }

    // Do something after component renders
    /* ß */

    /*useEffect(() => {
        if (localStorage.getItem('user')) {
            setUsername(localStorage.getItem('user').toLowerCase())
        } else {
            setUsername('')
        }
    }, []);*/


    /*if (location.pathname.match(/Login/) || location.pathname.match(/Register/) ||
        location.pathname.match(/CompleteRegister/) || location.pathname.match(/Swagger/)) {
        return null;
    }*/
    function logOut() {
        confirmDialog({
            message: '¿Esta seguro que desea cerrar sesión?',
            header: 'Cerrar sesión',
            icon: 'pi pi-info-circle',
            position: 'top',
            accept,
            acceptLabel: 'Si',
            rejectLabel: 'No'
        });
    }

    const accept = () => {
        authenticationService.signOut();
    }

    const getNotifications = async () => {
        let client = localStorage.getItem('client') ? localStorage.getItem('client') : ''
        let entity = localStorage.getItem('entity') ? localStorage.getItem('entity') : ''
        try {
            await apis.getNotifications(entity, client, headers).then(res => {
                let notifications_ = []
                const global = res.data["GLOBAL_NOTIFICATION"] ? res.data["GLOBAL_NOTIFICATION"] : []
                const user = res.data["USER_NOTIFICATION"] ? res.data["USER_NOTIFICATION"] : []
                if (global.length > 0) {
                    notifications_ = [...global]
                }
                if (user.length > 0) {
                    notifications_ = [...notifications_, ...user]
                }
                setNotifications([...notifications_])
            })
        }
        catch (err) {
            console.log("Wait")
        }
    }

    const checkNotifications = async (id) => {
        const payload = {
            CLIENT: localStorage.getItem('client'),
            ENTITY: localStorage.getItem('entity'),
            ID: id
        }
        try {
            await apis.checkNotification(payload, headers).then(res => {
                let notifications_ = []
                const global = res.data["GLOBAL_NOTIFICATION"] ? res.data["GLOBAL_NOTIFICATION"] : []
                const user = res.data["USER_NOTIFICATION"] ? res.data["USER_NOTIFICATION"] : []
                if (global.length > 0) {
                    notifications_ = [...global]
                }
                if (user.length > 0) {
                    notifications_ = [...notifications_, ...user]
                }
                setNotifications([...notifications_])
                op.current.hide();
                toast.current.show({ severity: 'success', detail: "Notificación leída" });
            })
        }
        catch (err) {
            toast.current.show({ severity: 'warn', detail: err.response.data.message, sticky: true });
        }
    }

    const itemTemplate = (product, index) => {
        return (
            <div className="col-12" key={product.ID}>
                <div className={classNames('flex flex-column xl:flex-row xl:align-items-start p-4 gap-4', { 'border-top-1 surface-border': index !== 0 })}>
                    <div className="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
                        <div className="flex flex-column align-items-center sm:align-items-start gap-3">
                            <div className="flex flex-row">
                                <i className={product.ICON}
                                    style={{ color: product.COLOR, fontSize: '1.5rem' }}></i>
                                <div className="text-sm font-bold text-900 ml-3">{product.NAME}</div>
                            </div>
                            <span className="text-sm font-semibold text-justify">{product.NOTIFICATION}</span>
                        </div>
                        {product.TYPE === "USER" && <div className="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
                            <Button icon="pi pi-check" className="p-button-rounded" severity="success" text onClick={() => checkNotifications(product.ID)}></Button>
                        </div>}
                    </div>
                </div>
            </div>
        );
    };

    const listTemplate = (items) => {
        if (!items || items.length === 0) return null;

        let list = items.map((product, index) => {
            return itemTemplate(product, index);
        });

        return <div className="grid grid-nogutter">{list}</div>;
    };

    const modelo2 = (
        [
            {
                template: (item, options) => {
                    return (
                        <div>
                            <Toast ref={toast} />
                            <Button type="button" onClick={(e) => op.current.toggle(e)} style={{ backgroundColor: '#1061a2', border: 'none' }}>
                                <Avatar className="p-overlay-badge" icon="pi pi-bell" style={{ backgroundColor: '#1061a2', color: '#ffffff', width: '100%' }} size="normal">
                                    {notifications.length > 0 && <Badge className="p-badge-danger" value={notifications.length} />}
                                </Avatar>
                            </Button>
                            <OverlayPanel ref={op} style={{ width: '24rem', display: 'flex', justifyContent: 'center' }} className="scrollpanel-demo2">
                                {notifications.length > 0 ?
                                    <ScrollPanel
                                        className="custombar1"
                                        style={{
                                            // ...(open ? styleOpen : styleClose),
                                            height: '11rem',
                                            width: '24rem',
                                            textAlign: 'left !important',
                                            backgroundColor: 'white'
                                            // display: 'flex',
                                            // flexWrap: 'wrap'
                                        }}>
                                        <DataView value={notifications} listTemplate={listTemplate} />
                                    </ScrollPanel>
                                    :
                                    <div>No hay notificaciones pendientes</div>
                                }
                            </OverlayPanel>
                        </div>
                    )
                }
            },
            {
                label: localStorage.getItem("user"), template: (item, options) => {
                    if (companyLogo) {
                        return (
                            <div>
                                <Link className={options.className} to="/">
                                    <Avatar className="h-1" style={{ width: "3rem", marginRight: "0.5rem" }} image={companyLogo} />
                                    <span className={options.labelClassName}>{item.label}</span>
                                </Link>
                            </div>
                        )
                    }
                    else {
                        return (
                            <Link className={options.className} to="/">
                                <span className='pi pi-fw pi-user' style={{ marginRight: "0.5rem" }}></span>
                                <span className={options.labelClassName}>{item.label}</span>
                            </Link>
                        )
                    }
                }, command: () => {
                    history.push("/");
                }
            },
            {
                label: 'SALIR', icon: "pi pi-fw pi-power-off",
                command: () => {
                    if (localStorage.getItem("user")) {
                        logOut()
                    }
                    else {
                        window.location.href = "/"
                    }
                }
            }
        ]
    )

    const modelo3 = (
        [
            { label: localStorage.getItem("user"), icon: localStorage.getItem("user") && "pi pi-fw pi-user" },
            {
                label: 'SALIR', icon: 'pi pi-fw pi-power-off',
                command: () => {
                    if (localStorage.getItem("user")) {
                        logOut()
                    }
                    else {
                        window.location.href = "/"
                    }
                }
            }
        ]

    )

    // if (location.pathname.match(/Login/) || location.pathname.match(/Register/) ||
    //     location.pathname.match(/CompleteRegister/)) {
    //     return (
    //         <div ref={node} onClick={() => setText(user)} className="stuff" />
    //     )
    // }
    return (
        <div style={location.pathname.match(/Login/) || location.pathname.match(/Register/) ||
            location.pathname.match(/CompleteRegister/) || location.pathname.match(/APIDocumentation/) ? { display: "none" } : console.log("Si")}
            className="bar"
        >
            {/* <ConfirmDialog /> */}
            <div>
                <TabMenu model={localStorage.getItem("enabled") === "N" ? modelo3 : modelo2} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
            </div>
            <div>
                <Link to={localStorage.getItem("type") === "CLIENT" ? "/Certificate" : "/Home"}>
                    <Image src={process.env.REACT_APP_LOGO_NAVBAR}
                        style={companyLogo ?
                            { position: 'fixed', height: '7rem', width: "12rem", marginLeft: "3rem", zIndex: "191", marginTop: "-1.5rem" }
                            :
                            { position: 'fixed', width: "11rem", height: "6rem", marginLeft: "3rem", zIndex: "191", marginTop: "-1.2rem" }}
                        alt="MiRemuner"
                    />
                </Link>
            </div>
            <div ref={node} onClick={() => setText(user)}>
                <div>
                    <Burger open={open} setOpen={setOpen} />
                </div>
                {/* <Menu open={open} setOpen={setOpen} /> */}
            </div>
        </div>
    )

}

export default Navbar